
const highlightsData = {
	title: "Highlights",
	description: [
		"Meet some of the young people who have achieved great things while benefitting from our investment in South Africa’s youth.",
	],
	highlights: [
		{
			image: {
				src: "/assets/images/highlights/highlights-Nontobeko.jpg",
				alt: "Scholarship Programme",
			},
			tag: "Scholarship Programme",
			title: "Nontobeko Nzuza",
			subtitle: "Matric (1 distinction) ",
			description: [
				"Nontobeko attended the Clarendon High School for Girls in the Eastern Cape. She hopes to gain a Nursing degree, as well as to travel the world and explore new experiences. “I manifest my goals through hard work,” she says.",
			]
		},
		{
			image: {
				src: "/assets/images/highlights/highlights-Amanda.jpg",
				alt: "Scholarship Programme",
			},
			tag: "Scholarship Programme",
			title: "Amanda Yonelisa Kethwa",
			subtitle: "Matric (3 distinctions) ",
			description: [
				"At Rhenish Girls’ High in the Western Cape, Amanda was Highest Xhosa Language Achiever (2017) and won first place in Allan Gray’s 2019 Investment Challenge. Her long-term goals are to become an entrepreneur, and to open a school for underprivileged children. She is studying Law at Wits University.",
			]
		},
		{
			image: {
				src: "/assets/images/highlights/highlights-Shannon.jpg",
				alt: "Scholarship Programme",
			},
			tag: "Scholarship Programme",
			title: "Shannon Louw",
			subtitle: "Matric (3 distinctions)",
			description: [
				"Shannon attended the St. Cyprian’s School in the Western Cape where she achieved Academic Half Colours in Grades 10 and 12. She was also head of her school’s houses, as well as a cultural society and the Futsal (5-a-side soccer) team. She is studying Biology and Psychology at Stellenbosch University.",
			]
		},
		{
			image: {
				src: "/assets/images/highlights/highlights-Nthabiseng.jpg",
				alt: "Scholarship Programme",
			},
			tag: "Scholarship Programme",
			title: "Nthabiseng  Koloi",
			subtitle: "Matric (2 distinctions)",
			description: [
				"Nthabiseng attended the Diocesan School for Girls (DSG) in the Eastern Cape. She is studying Psychology at Wits University. “Ask for help when you need it because the journey is not easy, but you’re surrounded by love from the Tutuwa family,” she says.",
			]
		},
		{
			image: {
				src: "/assets/images/highlights/highlights-Ayakha.jpg",
				alt: "Scholarship Programme",
			},
			tag: "Scholarship Programme",
			title: "Ayakha Mahashe",
			subtitle: "Matric (3 distinctions)",
			description: [
				"At St Andrews College in the Eastern Cape, Ayakha achieved Academic Honours in 2020 and 2019. He also captained the school chess team as well as being a member of his provincial team. He is doing Actuarial Science at Wits University.",
			]
		},
		{
			image: {
				src: "/assets/images/highlights/highlights-Lathitha.jpg",
				alt: "Scholarship Programme",
			},
			tag: "Scholarship Programme",
			title: "Lathitha Xapa",
			subtitle: "Matric (2 distinctions)",
			description: [
				"At the Eastern Cape’s Collegiate Girls’ High School, Lathitha was deputy head girl. During high school, she spearheaded various projects tackling social issues such as gender-based violence, transformation in her school’s hostels and the effects of COVID-19. She is studying Law at UCT.",
			]
		},
		{
			image: {
				src: "/assets/images/highlights/highlights-Hannah.jpg",
				alt: "Scholarship Programme",
			},
			tag: "Scholarship Programme",
			title: "Hannah Jacobs",
			subtitle: "Matric (6 distinctions)",
			description: [
				"Hannah says she was ‘greatly impacted’ by Tutuwa’s Scholarship Programme. Her many achievements while at school include 10 awards, including Academic Full Colours in 2018, 2019 and 2020. She is doing Applied Statistics and Computer Science at Stellenbosch University.",
			]
		},
		{
			image: {
				src: "/assets/images/highlights/highlights-Khanya.jpg",
				alt: "Scholarship Programme",
			},
			tag: "Scholarship Programme",
			title: "Khanya Lugongolo",
			subtitle: "Matric (3 distinctions)",
			description: [
				"At the Diocesan School for Girls (DSG) in the Eastern Cape, Khanya excelled both academically and at sports, winning accolades for both. She is doing Aeronautical Engineering at UCT and hopes to ultimately graduate from MIT in the US.",
			]
		},
	]
};

export { highlightsData };
